import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Check, ChevronDown, Globe } from "lucide-react";
import { LANGUAGES } from "@/i18n/translations";
import { useLanguage } from "@/i18n/LanguageContext";

export const LanguageMenu = ({ testid = "teamup-language-switcher", compact = false }) => {
  const { lang, setLang } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        data-testid={testid}
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3.5 py-2 font-mono text-xs uppercase tracking-widest text-white/80 transition-colors duration-300 hover:border-brand/40 hover:text-white"
      >
        <Globe className="h-3.5 w-3.5 text-brand" />
        {!compact && <span>{lang}</span>}
        {compact && <span>{lang}</span>}
        <ChevronDown className={`h-3.5 w-3.5 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      <AnimatePresence>
        {open && (
          <motion.ul
            initial={{ opacity: 0, y: -6, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -6, scale: 0.98 }}
            transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-xl border border-white/10 bg-pitch-card/95 p-1.5 shadow-2xl shadow-black/60 backdrop-blur-xl"
          >
            {LANGUAGES.map((l) => (
              <li key={l.code}>
                <button
                  type="button"
                  data-testid={`lang-option-${l.code}`}
                  onClick={() => {
                    setLang(l.code);
                    setOpen(false);
                  }}
                  className={`flex w-full items-center justify-between rounded-lg px-3 py-2.5 text-sm transition-colors duration-200 ${
                    lang === l.code ? "bg-brand/10 text-brand" : "text-white/70 hover:bg-white/5 hover:text-white"
                  }`}
                >
                  <span>{l.name}</span>
                  {lang === l.code && <Check className="h-3.5 w-3.5" />}
                </button>
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
};
